import { Component, inject } from '@angular/core';
import { Auth, authState } from '@angular/fire/auth';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterModule } from '@angular/router';
import { CdkMenuModule } from '@angular/cdk/menu';
import { environment } from '../../environments/environment';
import { initialsFor } from '../super-admin-user-dialog/super-admin-user-dialog.component';
import { SuperAdminUserDialogService } from '../super-admin-user-dialog/super-admin-user-dialog.service';

// Dropdown behavior (outside-click dismissal, Escape, arrow keys, nested
// submenus) comes from CDK Menu; visuals stay Tailwind/Flowbite classes.
@Component({
    selector: 'app-secondary-nav',
    imports: [RouterModule, CdkMenuModule],
    templateUrl: './secondary-nav.component.html',
    styleUrl: './secondary-nav.component.css'
})
export class SecondaryNavComponent {
  private auth = inject(Auth);
  private userDialog = inject(SuperAdminUserDialogService);

  isMobileMenuOpen = false;

  // Order Simulation only exists in non-prod, so hide its menu item in production.
  isProduction = environment.name === 'production';

  // Avatar chip that opens the Super Admin User panel (which owns sign-out).
  // The panel itself is hosted by MainComponent so its backdrop can cover this nav.
  readonly user = toSignal(authState(this.auth), { initialValue: this.auth.currentUser });

  userInitials(): string {
    const u = this.user();
    return initialsFor(u?.displayName, u?.email);
  }

  openUserDialog() {
    this.closeMobileMenu();
    this.userDialog.open();
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  closeMobileMenu() {
    this.isMobileMenuOpen = false;
  }
}
